import { useMediaQuery } from "react-responsive";
import logoIcon from "../assets/logo-icon.png";

export default function Logo({ textColor }) {
    const isMobile = useMediaQuery({ maxWidth: 768 });

    return (
        <div className="flex items-center space-x-2">
            <img
                src={logoIcon}
                alt="FixerFind Logo"
                className="h-15 w-auto"
                style={{
                    height: isMobile ? "35px" : "40px",
                    width: isMobile ? "35px" : "40px",
                    borderRadius: "25%",
                    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.20)",
                }}
            />
            <span
                className="text-xl"
                style={{
                    color: textColor,
                    fontSize: isMobile ? "1.7rem" : "1.8rem",
                    fontFamily:
                        "Arciform, Franklin Gothic Medium, Arial Narrow, Arial, sans-serif",
                    textDecoration: "none",
                    fontWeight: "300",
                    marginTop: "5px",
                }}
            >
                FixerFind
            </span>
        </div>
    );
}
